<script>
    import MAXLENGTH from "@/constants/maxlength";
    import utilManager from "@/assets/plugins/mps-common/util/util-manager";
    import fileManager from "@/assets/plugins/mps-common/file/file-manager";
    import routerManager from "@/assets/plugins/mps-common/router/router-manager";
    import {CODE} from "@/model/code";
    import Permissions from "@/constants/permissions";

    export default {
        name: "DataMixin",
        data() {
            return {
                MAXLENGTH: MAXLENGTH,
                utilManager: utilManager,
                fileManager: fileManager,
                routerManager: routerManager,
                CODE: CODE,
                Permissions: Permissions,
            };
        },
        methods: {
        },
    }
</script>